export default {
  root: {
    'white-space': 'pre-wrap',
  },
}
